<template>
    <input type="text" v-model="content" :disabled="disable" :readonly="readonly" />
</template>

<script>
    export default {
        props: ['value', 'disable', 'readonly', 'options'],
        data() {
            return {
                content: this.value
            };
        },
        mounted() {
            if (this.disable) return;

            var id = uniqid();
            let $this = this;
            $(this.$el).attr("id", id);
            var parent = $(this.$el).parent();

            parent.prev().attr("for", id);
            parent.next().attr("id", id+"-message");

            let picker = $(this.$el).datepicker({
                uiLibrary: 'bootstrap4',
                open(e){
                    $(this).closest(".form-datepicker").addClass("active");
                    $(this).closest(".form-datepicker").removeClass("success error");
                },
                close(e){
                    $(this).closest(".form-datepicker").removeClass("active");
                },
                change(e, type){
                    let val = $(this).val();
                    const splitVal = val.split("/");

                    if (splitVal.length === 3 && splitVal[2].length === 2 && parseInt(splitVal[2]) < 50) {
                        splitVal[2] = "20" + splitVal[2];
                        val = splitVal.join("/");
                    }

                    this.content = val;
                    $(this).trigger("update");
                    $this.$emit('input', val);
                },
                ...this.options,
            });

            parent.on("click", ()=>{
               picker.open();
            });

            $(this.$el).val(this.content);

        },
        watch: {

            content(val){
                this.$emit('input', val);
            },

            value(val){
                this.content = val;
            }

        },
        methods:{

        },
        destroyed() {

        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/elements/datepicker.vue